/**
 * Collage Overlay Positioning
 * Centers overlays exactly on product edges with randomized vertical placement
 * Distributes multiple overlays across left and right edges
 */

(function() {
  'use strict';

  // Distribute overlays across edges: alternates left/right, ensuring coverage
  function getEdgeAssignments(count) {
    if (count === 1) return ['left'];
    if (count === 2) return ['left', 'right'];
    if (count === 3) return ['left', 'right', 'left'];
    return [];
  }

  // Get vertical zones for overlays on the same edge to prevent overlap
  function getVerticalZones(edgeAssignments) {
    var leftCount = edgeAssignments.filter(function(e) { return e === 'left'; }).length;
    var rightCount = edgeAssignments.filter(function(e) { return e === 'right'; }).length;
    var leftIndex = 0;
    var rightIndex = 0;

    return edgeAssignments.map(function(edge) {
      var count = edge === 'left' ? leftCount : rightCount;
      var index = edge === 'left' ? leftIndex++ : rightIndex++;

      if (count === 1) {
        // Full range
        return { min: 0.1, max: 0.9 };
      } else if (count === 2) {
        // Split into upper and lower zones
        return index === 0
          ? { min: 0.1, max: 0.4 }
          : { min: 0.6, max: 0.9 };
      } else {
        // Three on same edge (unlikely but handle it)
        if (index === 0) return { min: 0.05, max: 0.3 };
        if (index === 1) return { min: 0.4, max: 0.6 };
        return { min: 0.7, max: 0.95 };
      }
    });
  }

  // Get random vertical position within a zone
  function getRandomTopInZone(productTop, productHeight, zone) {
    var range = zone.max - zone.min;
    return productTop + (Math.random() * range + zone.min) * productHeight;
  }

  function positionCollage1Overlays(collage) {
    var product = collage.querySelector('.module-collage-1__product');
    var overlays = collage.querySelectorAll('.module-collage-1__overlay');

    if (!product || overlays.length === 0) return;

    var collageRect = collage.getBoundingClientRect();
    var productRect = product.getBoundingClientRect();

    var leftEdge = productRect.left - collageRect.left;
    var rightEdge = productRect.right - collageRect.left;
    var productTop = productRect.top - collageRect.top;
    var productHeight = productRect.height;

    var edges = getEdgeAssignments(overlays.length);
    var zones = getVerticalZones(edges);

    overlays.forEach(function(overlay, index) {
      var overlayWidth = overlay.offsetWidth;
      var edge = edges[index] || 'left';
      var zone = zones[index];
      var xPos = edge === 'left'
        ? leftEdge - overlayWidth / 2
        : rightEdge - overlayWidth / 2;

      overlay.style.left = xPos + 'px';
      overlay.style.top = getRandomTopInZone(productTop, productHeight, zone) + 'px';
      overlay.style.transform = 'translateY(-50%)';
    });
  }

  function positionCollage2Overlays(collage) {
    var products = collage.querySelectorAll('.module-collage-2__product');
    var leftOverlays = collage.querySelectorAll('.module-collage-2__overlay--left');
    var rightOverlays = collage.querySelectorAll('.module-collage-2__overlay--right');

    if (products.length < 2) return;

    var collageRect = collage.getBoundingClientRect();
    var leftProduct = products[0];
    var rightProduct = products[1];

    var leftProductRect = leftProduct.getBoundingClientRect();
    var rightProductRect = rightProduct.getBoundingClientRect();

    // Position left product overlays (can use left or right edge of left product)
    if (leftOverlays.length > 0) {
      var leftEdges = getEdgeAssignments(leftOverlays.length);
      var leftZones = getVerticalZones(leftEdges);
      var lpLeft = leftProductRect.left - collageRect.left;
      var lpRight = leftProductRect.right - collageRect.left;
      var lpTop = leftProductRect.top - collageRect.top;
      var lpHeight = leftProductRect.height;

      leftOverlays.forEach(function(overlay, index) {
        var overlayWidth = overlay.offsetWidth;
        var edge = leftEdges[index] || 'left';
        var zone = leftZones[index];
        var xPos = edge === 'left'
          ? lpLeft - overlayWidth / 2
          : lpRight - overlayWidth / 2;

        overlay.style.left = xPos + 'px';
        overlay.style.top = getRandomTopInZone(lpTop, lpHeight, zone) + 'px';
        overlay.style.transform = 'translateY(-50%)';
      });
    }

    // Position right product overlays (can use left or right edge of right product)
    if (rightOverlays.length > 0) {
      var rightEdges = getEdgeAssignments(rightOverlays.length);
      var rightZones = getVerticalZones(rightEdges);
      var rpLeft = rightProductRect.left - collageRect.left;
      var rpRight = rightProductRect.right - collageRect.left;
      var rpTop = rightProductRect.top - collageRect.top;
      var rpHeight = rightProductRect.height;

      rightOverlays.forEach(function(overlay, index) {
        var overlayWidth = overlay.offsetWidth;
        var edge = rightEdges[index] || 'right';
        var zone = rightZones[index];
        // For right product, swap the edge interpretation (outer = right, inner = left)
        var xPos = edge === 'left'
          ? rpRight - overlayWidth / 2  // 'left' assignment means outer (right edge)
          : rpLeft - overlayWidth / 2;   // 'right' assignment means inner (left edge)

        overlay.style.left = xPos + 'px';
        overlay.style.top = getRandomTopInZone(rpTop, rpHeight, zone) + 'px';
        overlay.style.transform = 'translateY(-50%)';
      });
    }
  }

  function positionAllOverlays() {
    document.querySelectorAll('.module-collage-1').forEach(positionCollage1Overlays);
    document.querySelectorAll('.module-collage-2').forEach(positionCollage2Overlays);
  }

  // Run after images load for accurate dimensions
  function init() {
    if (document.readyState === 'complete') {
      positionAllOverlays();
    } else {
      window.addEventListener('load', positionAllOverlays);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-position on resize
  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(positionAllOverlays, 100);
  });

  // Re-position on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    setTimeout(function() {
      event.target.querySelectorAll('.module-collage-1').forEach(positionCollage1Overlays);
      event.target.querySelectorAll('.module-collage-2').forEach(positionCollage2Overlays);
    }, 100);
  });
})();
